module.exports = __webpack_public_path__ + "img/logo.b28a3c2b.webp";